import { HttpClient } from 'api/http-client';
import { ProjectId } from 'api/models';
import {
  AccountVisibility,
  VisibilityMeta,
  VisibilityId,
  ProjectVisibility,
} from './types';

class VisibilityHttpClient extends HttpClient {
  //  `/init` call will have GET `visibility-settings` response. so not adding that api here.

  public async createAccountVisibilitySettings(
    data: VisibilityMeta,
  ): Promise<AccountVisibility> {
    return this.post('/visibility-settings', {
      visibilityMeta: data,
    });
  }

  public async createProjectVisibilitySettings(
    [, projectId]: ProjectId,
    data: VisibilityMeta,
  ): Promise<ProjectVisibility> {
    return this.post('/visibility-settings', {
      visibilityMeta: data,
      projectId,
    });
  }

  public async updateAccountVisibilitySettings<AccountVisibility>(
    [, visibilityId]: VisibilityId,
    data: VisibilityMeta,
  ): Promise<AccountVisibility> {
    return this.put(`/visibility-settings/${visibilityId}`, {
      visibilityMeta: data,
    });
  }

  public async updateProjectVisibilitySettings<ProjectVisibility>(
    [, visibilityId]: VisibilityId,
    data: VisibilityMeta,
  ): Promise<ProjectVisibility> {
    return this.put(`/visibility-settings/${visibilityId}`, {
      visibilityMeta: data,
    });
  }
}

export const VisibilityAPI = new VisibilityHttpClient();
